<template>
  <div class="club-block">
    <div class="left-side">
      <div class="logo"><img :src="info.avatar" alt="club-image" /></div>
      <p class="address">{{ info.address }}</p>
    </div>
    <div class="right-side">
      <nuxt-link
        tag="a"
        :to="
          clubURL
            ? localePath({
                name: 'location-club-id',
                params: { id: clubURL, location: city }
              })
            : ''
        "
        class="title"
        @click.native="checkModeration"
      >
        <i class="icon-route" />
        {{ info.title }}
      </nuxt-link>
      <p class="address">{{ info.address }}</p>
      <Scheduler
        :schedule-obj="scheduleData"
        :append-to-body="appendToBody"
        :trigger="trigger"
      />
    </div>
    <div v-if="trainings.length" class="trainings-block">
      <p v-for="tr in trainings" :key="tr.id" class="training">
        <span class="name">{{ tr.training_type.value }}</span>
        <span class="time-price">
          <i class="icon-time" />
          <span class="time">{{ tr.duration }} {{ periodType(tr) }}</span>
          <span class="price">{{ tr.cost }} {{ currSign }}</span>
        </span>
      </p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import TimePeriodMixin from '@/dependencies/mixins/profile/time-period'
import Scheduler from '@/components/Common/Scheduler/SсhedulePopover'

export default {
  name: 'WorkplaceClubItem',
  components: { Scheduler },
  mixins: [TimePeriodMixin],
  props: {
    club: {
      type: Object,
      default: () => {}
    },
    appendToBody: {
      type: Boolean,
      default: false
    },
    trigger: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters({
      currSign: 'user/getCurrencySign',
      city: 'location/getUrlKey'
    }),
    info() {
      return this.club?.info
    },
    trainings() {
      return this.club?.trainings
    },
    clubURL() {
      return this.club?.club?.url
    },
    scheduleData() {
      return this.club?.scheduleConverted
    }
  },
  methods: {
    periodType(_tr) {
      return this.periods.find((el) => el.period_type_id === _tr.period_type_id)
        ?.name
    },
    checkModeration() {
      if (!this.clubURL) this.$bus.$emit('warning', 'club-not-moderated')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~assets/css/variables';

.club-block {
  margin-bottom: 18px;
  display: flex;
  flex-wrap: wrap;

  &:last-child {
    margin-bottom: 0;
  }

  .left-side {
    width: 27%;
    margin-right: 10px;

    .logo {
      width: 100%;

      img {
        width: 100%;
        height: auto;
        border-radius: 3px;
      }
    }

    .address {
      display: none;
    }
  }

  .right-side {
    width: 69%;

    .title {
      font-size: 16px;
      color: $primary;
      line-height: normal;
      margin-bottom: 7px;

      i {
        display: none;
      }
    }

    .address {
      line-height: normal;
      font-size: 13px;
      color: $gray;
    }
  }

  .trainings-block {
    width: 100%;
    line-height: normal;
    margin-top: 10px;
    border-radius: 3px;
    background-color: $gray-lighter;
    border: 1px solid #f0f0f0;
    padding: 10px;

    .training {
      display: flex;
      justify-content: space-between;
      margin-bottom: 10px;

      &:last-child {
        margin-bottom: 0;
      }

      .name {
        font-size: 12px;
      }

      .time-price {
        line-height: 1.2;
        color: $gray;

        &:not(i) {
          font-size: 12px;
        }

        i {
          font-size: 10px;
        }

        .time {
          padding-right: 4px;
        }

        .price {
          color: $primary;
          border-left: 1px solid $primary;
          padding-left: 6px;
        }
      }
    }
  }
}

@media (min-width: 510px) {
  .club-block {
    .left-side {
      width: 15%;
    }

    .right-side {
      width: 83%;
    }
  }
}

@media (min-width: 768px) {
  .club-block {
    display: block;
    min-height: 220px;

    .right-side {
      width: 81%;
      float: right;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .title {
        margin-bottom: 0;
        font-size: 22px;
        width: 66%;

        &:hover {
          cursor: pointer;
          text-decoration: underline;
        }

        i {
          font-size: 16px !important;
          display: inline-block;
        }
      }
      .tr-shedule {
        margin-top: 0;

        span {
          font-size: 18px;
          color: #474747;
        }
      }
      .address {
        display: none;
      }
    }

    .left-side {
      width: 17%;
      float: left;

      .address {
        display: block;
        font-size: 15px;
        color: $gray;
        text-align: center;
      }
    }

    .trainings-block {
      float: right;
      width: 81%;
      padding: 15px;

      .training {
        .name {
          font-size: 18px;
          color: #474747;
        }

        .time-price {
          &:not(i) {
            font-size: 16px;
          }

          i {
            font-size: 14px;
          }
        }
      }
    }
  }
}
</style>
